import React from 'react'
import { connect } from 'react-redux'

import moment from 'moment'
import { fetchWithTimeout, getQueryParams } from '../utils/query'
import ReactToPrint from 'react-to-print'

import { baseURL } from '../http'
import { MsgToUserActionCreators } from '../redux/reducers/msgToUser/action-creators'
import { MessageType } from '../redux/reducers/msgToUser/types'

import errorPayment from '../assets/error-payment.svg'
import successPayment from '../assets/success-payment.svg'
import { Loader } from '../components'

import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Languages } from '../redux/reducers/language/languageData'

import mobApp from '../assets/mob-app.png'
import appStore from '../assets/app-store.png'
import googleStore from '../assets/google-store.png'
import paymentMethod from '../assets/payment-method.png'

import '../styles/components/GuestCheck1356.scss'
import { documentTitle } from '../utils/consts'

class GuestCheckScreen extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      isModalVisible: false,
      isLoading: false,
      inputMail: '',
      savedCheckData: undefined,
      localName: '',
      historyField: [],
      isCorrectEmail: true,
      msgType: 0,
      inputPhone: '',
      isCorrectPhone: 'false',
    }
  }

  async componentDidMount() {
    document.title = documentTitle
    await this.getCheckData()
    await this.getPromoData()
  }

  notify = () => {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)

    let message
    switch (this.state.msgType) {
      case 1:
        message = language.sendCheckMsgSuccess
        break
      case 2:
        message = language.sendCheckLimitError
        break
      case 3:
        message = language.sendSmsMsgSuccess
        break
      case 4:
        message = language.smsLimitError
        break
      default:
        message = language.someError
        break
    }

    toast(message, {
      position: toast.POSITION.TOP_CENTER,
    })
  }

  async getCheckData() {
    const { orderId } = getQueryParams()

    this.setState({ isLoading: true })
    try {
      await fetchWithTimeout(
        `${baseURL}/guest/rurl_payment_guest?orderId=${orderId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Payment-Origin': 'frames',
          },
        },
      )

      const response = await fetchWithTimeout(
        `${baseURL}/guest/receipt2?orderId=${orderId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Payment-Origin': 'frames',
          },
        },
      )
      console.warn('getCheckDataResponse', response)
      if (response.status === 200) {
        const json = await response.json()
        console.warn('getCheckDataJson', json)
        console.warn('getCheckDataHistoryField', json.item.fields.historyField)

        if (json.resultCodes === 'OK') {
          this.setState({ savedCheckData: json.item })
          this.setState({ localName: json.item.localName['valueAz'] })
          this.saveMainField(json.item.fields.historyField)
        }
      } else {
        // this.props.MsgToUserState(MessageType.SomeError);
      }
    } catch (e) {
      console.warn('error', e)
      this.props.MsgToUserState(MessageType.CatchError)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  async getPromoData() {
    const { orderId } = getQueryParams()

    this.setState({ isLoading: true })
    try {
      const response = await fetchWithTimeout(
        `${baseURL}/guest/receipt/promocode?orderId=${orderId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Payment-Origin': 'frames',
          },
        },
      )
      if (response.status === 200) {
        const json = await response.json()

        if (json.history.resultCodes === 'OK') {
          this.setState({ promocode: json.promocode })
        }
      } else {
        // this.props.MsgToUserState(MessageType.SomeError);
      }
    } catch (e) {
      console.warn('error', e)
      this.props.MsgToUserState(MessageType.CatchError)
    } finally {
      this.setState({ isLoading: false })
    }
  }
  async sendCheckToMail() {
    this.setState({ isLoading: true })
    const { orderId } = getQueryParams()

    try {
      const response = await fetchWithTimeout(
        `${baseURL}/guest/receipt/send?orderId=${orderId}&email=${this.state.inputMail}&sendType=email`,
        {
          method: 'POST',
          headers: {
            'Payment-Origin': 'frames',
          },
        },
      )
      console.warn('responseGuestSend', response)
      if (response.status === 200) {
        const json = await response.json()
        console.warn('jsonnnr', json)
        if (json.resultCodes === 'OK') {
          this.setState({ msgType: 1 })
        } else if (json.resultCodes === 'EMAIL_SEND_LIMIT_EXCEEDED') {
          this.setState({ msgType: 2 })
        }
      } else {
        console.warn('error')
        this.setState({ msgType: 0 })
      }
    } catch (e) {
      console.warn('error', e)
      this.setState({ msgType: 0 })
    } finally {
      this.setState({ isLoading: false })
      this.notify()
    }
  }
  async sendLinkToSms() {
    const { inputPhone, isCorrectPhone } = this.state
    if (!isCorrectPhone) {
      return
    }

    this.setState({ isLoading: true })

    try {
      const response = await fetchWithTimeout(
        `${baseURL}/guest/send-sms-with-link?phoneNumber=${inputPhone}`,
        {
          method: 'POST',
          headers: {
            'Payment-Origin': 'frames',
          },
        },
      )
      console.warn('responseGuestSendLink', response)
      if (response.status === 200) {
        const json = await response.json()
        console.warn('jsonnnr', json)
        if (json.resultCodes === 'SMS_SEND') {
          this.setState({ msgType: 3 })
        } else {
          this.setState({ msgType: 4 })
        }
      } else {
        console.warn('error')
        this.setState({ msgType: 0 })
      }
    } catch (e) {
      console.warn('error', e)
      this.setState({ msgType: 0 })
    } finally {
      this.setState({ isLoading: false })
      this.notify()
    }
  }
  saveMainField(historyField) {
    let fields = []
    for (const i in historyField) {
      const item = historyField[i]
      let field = { enumFieldValue: {}, localName: {}, value: '' }
      field.enumFieldValue = item.enumFieldValue
      field.localName = item.localName
      field.value = item.value
      fields.push(field)
    }
    this.setState({ historyField: fields })
  }
  renderErrorMsgEmail(language) {
    if (!this.state.isCorrectEmail) {
      if (this.state.inputMail.length === 0) {
        return language.requiredError
      }
      return language.emptyError
    }
  }
  renderErrorMsgPhone(language) {
    if (!this.state.isCorrectPhone) {
      if (this.state.inputPhone?.length === 0) {
        return language.requiredError
      }
      return language.emptyError
    }
  }

  render() {
    const { language: selectedLanguage, langKey } = this.props.language
    const language = Languages(selectedLanguage)

    let { savedCheckData, promocode } = this.state
    console.log(`savedCheckData:`, savedCheckData)

    const regEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
    const regPhone = /^\+[1-9][0-9]*$/

    const paymentResultRender = () => {
      const checkResultLinkRender = () => {
        return (
          <div className='check_result-link'>
            {selectedLanguage === 'az' ? (
              <>
                Təbriklər! Bu ödəniş ilə siz{' '}
                {promocode?.bonusGiven ? promocode?.bonusGiven : null} bonus
                qazandınız. Əldə etmək üçün elə indi{' '}
                <a
                  href={`https://www.e-pul.az/epay/sign/up?paymentPromoCode=${promocode?.value}`}
                >
                  buradan
                </a>{' '}
                qeydiyyatdan keçin!
              </>
            ) : selectedLanguage === 'en' ? (
              <>
                Congratulations! You have earned{' '}
                {promocode?.bonusGiven ? promocode?.bonusGiven : null} bonuses
                with this payment. To get them, register{' '}
                <a
                  href={`https://www.e-pul.az/epay/sign/up?paymentPromoCode=${promocode?.value}`}
                >
                  here
                </a>{' '}
              </>
            ) : (
              <>
                Поздравляем! С этой оплаты вы заработали{' '}
                {promocode?.bonusGiven ? promocode?.bonusGiven : null} бонусы.
                Чтобы получить их, зарегистрируйтесь{' '}
                <a
                  href={`https://www.e-pul.az/epay/sign/up?paymentPromoCode=${promocode?.value}`}
                >
                  здесь
                </a>{' '}
              </>
            )}
          </div>
        )
      }

      return (
        <div
          className={
            savedCheckData
              ? 'check_result check_result--success'
              : 'check_result check_result--error'
          }
        >
          <div className='container container--check1356'>
            <div className='check_result-icon'>
              {savedCheckData ? (
                <img src={successPayment} alt='' />
              ) : (
                <img src={errorPayment} alt='' />
              )}
            </div>
            <div className='check_result-desc'>
              {savedCheckData ? language.paymentDone : language.paymentError}
            </div>
            {savedCheckData && checkResultLinkRender()}
          </div>
        </div>
      )
    }

    return (
      <>
        {/* {paymentResultRender()} */}
        <div className='check-cart-wrapper'>
          <div className='check-cart-inner'>
            {savedCheckData && (
              <div className='container container--check1356'>
                <div className='check_header'>
                  <div className='check_header-title'>
                    Ödəniş uğurla tamamlandı
                  </div>
                  <div className='check_header-sub-title'>
                    {(savedCheckData.amount / 100 + 1).toFixed(2)}{' '}
                    {savedCheckData.currency === 'AZN' ? 'AZN' : '$'}
                  </div>
                </div>
                <div className='check'>
                  <div className='check_data-items'>
                    <div className='check_data-item'>
                      <div className='check_data-item-title check-data-content'>
                        {language['Transaction number']}:
                      </div>
                      <div className='check_data-item-body check-data-content'>
                        {savedCheckData?.id}
                      </div>
                    </div>

                    {this.state.historyField.map((item, i) => {
                      let protocolLabel = 'Protocol'

                      if (selectedLanguage === 'az') {
                        protocolLabel = 'Protokol'
                      }

                      if (selectedLanguage === 'ru') {
                        protocolLabel = 'Протокол'
                      }

                      return (
                        <div key={i} className='check_data-item'>
                          <div className='check_data-item-title check-data-content'>
                            {protocolLabel}
                          </div>
                          <div className='check_data-item-body check-data-content'>
                            {item.value === 'A'
                              ? item.enumFieldValue[langKey]
                              : item.value}
                          </div>
                        </div>
                      )
                    })}

                    <div className='check_data-item'>
                      <div className='check_data-item-title check-data-content'>
                        {language.sum + ':'}
                      </div>
                      <div className='check_data-item-body check-data-content'>
                        {(savedCheckData.amount / 100 + 1).toFixed(2)}{' '}
                        {savedCheckData.currency === 'AZN' ? 'AZN' : '$'}
                      </div>
                    </div>

                    <div className='check_data-item'>
                      <div className='check_data-item-title check-data-content'>
                        {language.date + ':'}
                      </div>
                      <div className='check_data-item-body check-data-content'>
                        {moment(savedCheckData.insertDate).format(
                          'DD.MM.YYYY HH:mm',
                        )}
                      </div>
                    </div>

                    <div className='check_data-item'>
                      <div className='check_data-item-title check-data-content'>
                        RRN
                      </div>
                      <div className='check_data-item-body check-data-content'>
                        {savedCheckData.rrn}
                      </div>
                    </div>

                    <div className='check_data-item'>
                      <div className='check_data-item-title check-data-content'>
                        {language.cardNumber + ':'}
                      </div>
                      <div className='check_data-item-body check-data-content'>
                        {savedCheckData.pan}
                      </div>
                    </div>

                    <div className='check_data-item'>
                      <div className='check_data-item-title check-data-content'>
                        {language.Status}
                      </div>
                      <div className='check_data-item-body check-data-content'>
                        <div className='status'>
                          <span>{language.Successful}</span>
                        </div>
                      </div>
                    </div>

                    {/* <div className='check_send-mail'>
                <input
                  className='check_send-mail-input'
                  type='email'
                  onChange={e => {
                    this.state.inputMail && regEmail.test(e.target.value)
                      ? this.setState({
                          inputMail: e.target.value,
                          isCorrectEmail: true,
                        })
                      : this.setState({
                          inputMail: e.target.value,
                          isCorrectEmail: false,
                        })
                  }}
                  placeholder={'e-mail'}
                  value={this.state.inputMail}
                />
                <div className='check_send-mail-validate-message'>
                  {this.renderErrorMsgEmail(language)}
                </div>
                <button
                  className='check_send-mail-btn'
                  disabled={!this.state.isCorrectEmail || !this.state.inputMail}
                  onClick={() => {
                    this.sendCheckToMail()
                  }}
                >
                  {language.sendToEmail}
                </button>
                <ReactToPrint
                  trigger={() => (
                    <button
                      className='check_send-mail-btn'
                      onClick={() => {
                        this.contentRef.style.display = 'block'
                      }}
                    >
                      {language.checkPrint}
                    </button>
                  )}
                  content={() => this.contentRef}
                  pageStyle='print'
                  documentTitle='Onlayn Ödə | Onlayn Ödəmə Sistemi - EPUL'
                />
              </div> */}
                  </div>
                </div>
              </div>
            )}
            {/* <footer className='check_footer-wrapper'>
            <div className='check_footer'>
              <div className='check_footer-left-part'>
                <div className='check_footer-mobil-app-img'>
                  <img src={mobApp} alt='' />
                </div>
              </div>
              <div className='check_footer-info'>
                <div className='check_footer-info-title'>
                  {language.downloadEPul}
                </div>
                <div className='check_footer-info-sub-title'>
                  {language.enterNumberDownload}
                </div>
                <div className='check_footer-info-controller'>
                  <input
                    type='check_footer-info-controller-input'
                    onChange={e => {
                      this.state.inputPhone && regPhone.test(e.target.value)
                        ? this.setState({
                            inputPhone: e.target.value,
                            isCorrectPhone: true,
                          })
                        : this.setState({
                            inputPhone: e.target.value,
                            isCorrectPhone: false,
                          })
                    }}
                    placeholder={'+994501234567'}
                    value={this.state.inputPhone}
                  />
                  {this.renderErrorMsgPhone(language) && (
                    <div className='check_send-mail-validate-message check_send-mail-validate-message--mobile'>
                      {this.renderErrorMsgPhone(language)}
                    </div>
                  )}
                  <button
                    type='check_footer-info-controller-button'
                    onClick={() => {
                      this.sendLinkToSms()
                    }}
                  >
                    {language.getLink}
                  </button>
                </div>
                {this.renderErrorMsgPhone(language) && (
                  <div className='check_send-mail-validate-message check_send-mail-validate-message--desktop'>
                    {this.renderErrorMsgPhone(language)}
                  </div>
                )}
                <div className='check_footer-info-store'>
                  <div className='check_footer-info-store-app'>
                    <a
                      href='https://apps.apple.com/us/app/e-pul/id965770019'
                      target='_blank'
                      rel='noreferrer'
                    >
                      <img src={appStore} alt='' />
                    </a>
                  </div>
                  <div className='check_footer-info-store-google'>
                    <a
                      href='https://play.google.com/store/apps/details?id=az.epul.technopay.android&hl=ru&gl=US'
                      target='_blank'
                      rel='noreferrer'
                    >
                      <img src={googleStore} alt='' />
                    </a>
                  </div>
                </div>
              </div>
              <div className='check_footer-google-ios-app-icons'></div>
            </div>
          </footer>
          <div
            style={{
              display: 'none',
            }}
          >
            <div ref={el => (this.contentRef = el)} className='check_print'>
              <div className='check_print-items'>
                <div className='check_print-item'>
                  <div className='check_print-title'>
                    {language.date.toUpperCase()}
                  </div>
                  <div className='check_print-body'>
                    {moment(savedCheckData?.insertDate).format(
                      'DD.MM.YYYY HH:mm',
                    )}
                  </div>
                </div>

                <div className='check_print-item'>
                  <div className='check_print-title'>
                    {language.sum.toUpperCase()}
                  </div>
                  <div className='check_print-body check_print-amount'>
                    {(+savedCheckData?.amount / 100).toFixed(2)}{' '}
                    <div className='check_print-amount-currency'>
                      {savedCheckData?.currency === 'AZN' ? 'AZN' : '$'}
                    </div>
                  </div>
                </div>
                <div className='check_print-data'>
                  <div className='check_print-title'>{language.checkInfo}</div>
                  <div className='check_print-data_items'>
                    <div className='check_print-data-item'>
                      <div className='check_print-data-title'>
                        {language.checkNumber + ':'}
                      </div>
                      <div className='check_print-data-body'>
                        {savedCheckData?.id}
                      </div>
                    </div>
                    <div className='check_print-data-item'>
                      <div className='check_print-data-item-title'>
                        {language.service + ':'}
                      </div>
                      <div className='check_print-data-item-body'>
                        {this.state.localName}
                      </div>
                    </div>
                    <div className='check_print-data-item'>
                      <div className='check_print-data-item-title'>
                        {language.person + ':'}
                      </div>
                      <div className='check_print-data-item-body'>
                        {savedCheckData?.person}
                      </div>
                    </div>
                    {this.state.historyField.map((item, i) => {
                      return (
                        <div key={i} className='check_print-data-item'>
                          <div className='check_print-data-item-title'>
                            {item.localName[langKey] + ':'}
                          </div>
                          <div className='check_print-data-item-body'>
                            {item.value === 'A'
                              ? item.enumFieldValue[langKey]
                              : item.value}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              <div className='check_print-payment-method'>
                {language.paymentMethod}
                <div className='check_print-payment-method-icon'>
                  <img src={paymentMethod} alt='' />
                </div>
              </div>
            </div>
          </div> */}
            {this.state.isLoading && (
              <div className='loader-wrapper loader-wrapper--check1356'>
                <Loader />
              </div>
            )}
          </div>
        </div>
        <ToastContainer />
      </>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  guestPayment: state.guestPayment,
  language: state.language,
})
const mapDispatchToProps = {
  MsgToUserState: MsgToUserActionCreators.msgToUserState,
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestCheckScreen)
